
/* global define */
define('logger',['jquery', '_', 'hudl.ajax', 'json-copy'],
    function ($, _, ajax, jsonCopy) {
        'use strict';

        var windowIsUnloading = false,
            queuedLogs = [],
            onBeforeUnloadHandlers = $.Callbacks('once');

        // All logs are queued before actually sending, in order to make the requests in the
        // appropriate async/sync manner.
        function processLogs () {
            var log;
            while (log = queuedLogs.shift()) {
                log();
            }
        }

        /// <summary>
        /// A client-side logger, made to simplify logging and keep consistency.
        /// Intended future improvements: support batching/reducing (e.g. logging counts of an event as a single), 
        /// storing unsent logs in local storage (on page unload, etc.)
        /// </summary>

        function Logger (logName) {
            this._name = logName;
        }
        
        $.extend(Logger.prototype, {
            log: function (message, data) {
                var name = this._name;
                
                // queue up the log as a function
                queuedLogs.push(function () {
                    // handle the case conversion here (for now at least) because it's much easier than on the server
                    ajax.post('/Logging/LogData', { loggerName: name, message: message, data: jsonCopy.toPascalCase(data) }, { async: !windowIsUnloading });
                });

                // defer so that we can catch logs that occur immediately before page navigation
                _.defer(function () { _.defer(processLogs); });
            }
            
// lyleshearer 5/20/2013 - make this log a trace, but strip off the first few lines so there's no confusing "TypeError: Object #<Object> has no method 'undef'" line
//            trace: function (message) {
//            }
        });

        $.extend(Logger, {
            onBeforeUnload: onBeforeUnloadHandlers.add
        });
        
        // We want to catch window unload (and beforeunload, to be thorough) events and make sure
        // that any queued logs are sent synchronously (to prevent getting canceled by the browser). 
        $(function () {
            $(window).on('beforeunload unload', function () {
                windowIsUnloading = true;

                onBeforeUnloadHandlers.fire();

                processLogs();
            });
        });


        return Logger;
    });